import React, { useMemo } from "react";
import { useInterviewContext } from "../InterviewContext";
import { ReactDropdownTreeSelectMemoized } from "./../../dropdownTree.container";
import { useTranslation } from "react-i18next";
import "../../styles/mobilitySelect.scss";
import "react-dropdown-tree-select/dist/styles.css";

const Mobility = () => {
  const { mobility, interview, setInterview, errors } = useInterviewContext();

  const { t } = useTranslation();

  const handleChange = useMemo(
    () => (_, selectedValues) => {

      setInterview((prevInterview) => ({
        ...prevInterview,
        availabilityAndConditions: {
          ...prevInterview.availabilityAndConditions,
          mobilityId: selectedValues.map((val) => val.value),
          mobility: prevInterview.availabilityAndConditions.mobility?.map(
            (mobility) => { 
              mobility.checked = selectedValues.map((val) => val.value)?.includes(
                mobility.value
              );
              mobility.children = mobility.children?.map((children) => {
                children.checked =
                selectedValues.map((val) => val.value)?.includes(
                    children.value
                  ) || mobility.checked === true;
                  return children;
              });
              return mobility;
            }
          )
        }
      }));
    },
    []
  );

  return (
    <div className="mobility">
      <h1>{t("Mobility*")}</h1>
      {errors.mobilityId && (
        <div className="error-msg">{errors.mobilityId}</div>
      )}
      {interview.availabilityAndConditions.mobility ? (
        <ReactDropdownTreeSelectMemoized
          data={interview.availabilityAndConditions.mobility}
          onChange={handleChange}
        />
      ) : (
        <ReactDropdownTreeSelectMemoized
          data={mobility}
          onChange={handleChange}
        />
      )}
    </div>
  );
};

export default Mobility;
